module.exports = __webpack_public_path__ + "images/factoryIcon.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/factoryIcon.png
// module id = 2129
// module chunks = 0